import { render, staticRenderFns } from "./proveVerify.vue?vue&type=template&id=122d0857&scoped=true&"
import script from "./proveVerify.vue?vue&type=script&lang=js&"
export * from "./proveVerify.vue?vue&type=script&lang=js&"
import style0 from "./proveVerify.vue?vue&type=style&index=0&id=122d0857&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122d0857",
  null
  
)

export default component.exports